import { workflowAxiosGet } from "../utils/workflowAuthHeaders";

const BASE_URL = "https://workflow.grupocenze.com.br:38137/rest/";

/** GET INT_CRM_APP_CONDPGTO — condições de pagamento */
const fetchCondPgtoCrm = async ({
  empresa = "01",
  filial = "01",
  token,
  username,
  password,
} = {}) => {
  try {
    const response = await workflowAxiosGet(
      `${BASE_URL}INT_CRM_APP_CONDPGTO`,
      {
        params: {
          empresa,
          filial,
        },
      },
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar condições de pagamento (CRM):", error);
    throw error;
  }
};

export default fetchCondPgtoCrm;
